import { Districte, DistricteEnum } from '../shared/districte.d';

export type AssessoriaDistricte = Districte;

export const AssessoriaDistricteEnum = { ...DistricteEnum };
